import { RouterProvider } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import AppRouter from "./helpers/AppRoutes";
import { ThemeProvider } from "./context/ThemeContext";

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <RouterProvider router={AppRouter} />
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
